import {
  MC_MISMATCH_DATA_FAILED,
  MC_MISMATCH_DATA_REQUEST,
  MC_MISMATCH_DATA_SUCCESS,
} from "app/redux/actions/Factory/Dressing/mcMismatchData/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const mcMismatchDataReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case MC_MISMATCH_DATA_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case MC_MISMATCH_DATA_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case MC_MISMATCH_DATA_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
